import { useStaticQuery, graphql } from "gatsby"
import { useCallback } from "react"

interface storyBlokOnlineProduct {
  uuid: string
  content: string
  full_slug: string
}

export const useGetStoryblokOnlineProduct = () => {
  const data = useStaticQuery(graphql`
    query StoryblokOnlineProducts {
      allStoryblokEntry(
        filter: { full_slug: { regex: "/settings/online-products/" } }
      ) {
        edges {
          node {
            uuid
            content
            full_slug
          }
        }
      }
    }
  `)

  return useCallback(
    (
      id: string,
      queryBy: "id" | "name" | "slug" = "id"
    ): Storyblok.OnlineProductConfig | null => {
      const onlineProduct = data.allStoryblokEntry.edges.find(
        (onlineProduct: { node: storyBlokOnlineProduct }) => {
          if (queryBy === "slug") {
            return onlineProduct.node.full_slug === id
          } else if (queryBy === "name") {
            const content = JSON.parse(onlineProduct.node.content)
            return content.name === id
          } else {
            return onlineProduct.node.uuid === id
          }
        }
      )

      if (onlineProduct) {
        return {
          uuid: onlineProduct.node.uuid,
          ...JSON.parse(onlineProduct.node.content),
        }
      }

      return null
    },
    [data]
  )
}
